module.exports = {
    AFFILIATE_ID: 'none',
    VIDEO_NETWORK: 'abc',
    APP_NAME: 'dancingwiththestars',
    APP_VERSION: '1.3',
    PAGE_NAME: 'abc:dwts',
    SITE_DIFFERENTIATOR: 'dwts:site'
};



// WEBPACK FOOTER //
// ./app/scripts/constants/omniture.js